export default __webpack_public_path__ + "/images/chocolate-chip-cookie.jpg";